<template>
  <div v-if="_visible" class="addApplicationMange">
    <module-title :title="handleType === 'add' ? '添加应用' : '编辑应用'">
      <div class="right">
        <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="back">
          返回
        </el-button>
      </div>
    </module-title>
    <div class="add-application-wrapper">
      <el-form
        ref="addApplicationForm"
        class="add-application-form"
        :model="addApplicationForm"
        :rules="handleRules"
        label-position="right"
        label-width="200px"
      >
        <el-form-item label="应用名称：" prop="name">
          <el-input
            v-model="addApplicationForm.name"
            name="name"
            :maxlength="10"
            placeholder="请输入应用名称"
            class="handle-form-input"
            :disabled="handleType === 'edit'"
          />
        </el-form-item>
        <el-form-item label="应用编码：" prop="code">
          <el-input
            v-model="addApplicationForm.code"
            name="code"
            :maxlength="50"
            placeholder="请输入应用编码"
            class="handle-form-input"
            :disabled="handleType === 'edit'"
          />
          <!-- <el-select
            v-model="addApplicationForm.code"
            name="status"
            size="medium"
            class="handle-form-input"
          >
            <el-option
              v-for="item in codeArr"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select> -->
        </el-form-item>
        <el-form-item label="应用类型：" prop="appType">
          <el-select
            v-model="addApplicationForm.appType"
            name="status"
            size="medium"
            class="handle-form-input"
          >
            <el-option
              v-for="item in appTypeArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="应用图标：" prop="logoUrl" class="app-update">
          <upload-file
            :props="{
              serveCode: 'small_app_logo',
              accept: '.png, .jpg, .jpeg',
              type: ['image/jpeg', 'image/gif', 'image/png']
            }"
            @uploadSucess="uploadSucessFn"
            @fileUploading="fileUploadingFn"
            @apkParser="apkParserFn"
          >
            <img
              v-if="addApplicationForm.logoUrl"
              :src="addApplicationForm.logoUrl"
              class="avatar"
            >
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </upload-file>
          <div class="el-upload__tip update-text">
            请上传png、jpg格式、分辨率为96*96的应用图标
          </div>
        </el-form-item>
        <el-form-item label="应用标签：" prop="terminal">
          <el-radio-group
            v-model="addApplicationForm.terminal"
            :disabled="handleType === 'edit'"
          >
            <el-radio v-for="item in terminalArr" :key="item.id" :label="item.id">
              {{
                item.name
              }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="支持终端：" prop="applyTerminals">
          <el-checkbox-group v-model="addApplicationForm.applyTerminals">
            <el-checkbox label="1">
              教师客户端
            </el-checkbox>
            <el-checkbox label="2" @change="changeBox">
              学生客户端（是否展示应用图标）
            </el-checkbox>
            <span style="margin-left:-30px;margin-right:20px;width:120px;display: inline-block;">
              <el-select v-model="addApplicationForm.studentClientDisplay" size="small" :disabled="disaibleSelect">
                <el-option label="是" :value="1" />
                <el-option label="否" :value="0" />
              </el-select>
            </span>
            <el-checkbox label="3">
              教师微信小程序
              <el-tooltip class="tip-icon" effect="dark" content="勾选后，该应用可在教师微信小程序中打开使用" placement="right">
                <i class="el-icon-question" />
              </el-tooltip>
            </el-checkbox>
            <el-checkbox label="4">
              家长微信小程序
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="适用用户：" prop="applyTypes">
          <el-checkbox-group v-model="addApplicationForm.applyTypes">
            <el-checkbox label="1">
              个人
            </el-checkbox>
            <el-checkbox label="2">
              组织
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- <el-form-item label="支持业务端：" prop="support">
          <el-checkbox-group
            v-model="addApplicationForm.support"
            class="group"
          >
            <el-checkbox
              v-for="item in supportArr"
              :label="item.id"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item> -->
        <el-form-item label="适用年级：" prop="stageArr">
          <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">
            全选
          </el-checkbox>
          <el-checkbox-group
            v-model="addApplicationForm.stageArr"
            class="group"
            @change="stageClick"
          >
            <el-checkbox
              v-for="item in stageArr"
              :key="item.id"
              :label="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="适用学科：" prop="subjectArr">
          <el-checkbox
            v-model="subjectCheckAll"
            :indeterminate="subjectIsIndeterminate"
            @change="subjectCheckAllChange"
          >
            全选
          </el-checkbox>
          <el-checkbox-group
            v-model="addApplicationForm.subjectArr"
            class="group"
            @change="subjectClick"
          >
            <el-checkbox v-for="item in subjectArr" :key="item.subjectId" :label="item.subjectId">
              {{
                item.subjectName
              }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="前端下载虚拟系数：" prop="coefficient">
          <el-input
            v-model="addApplicationForm.coefficient"
            name="coefficient"
            :maxlength="9"
            class="handle-form-input"
            @input="numberInput"
          />
          <el-tooltip
            class="downNum"
            effect="dark"
            content="前端下载次数显示 = 实际下载+虚拟次数"
            placement="right"
          >
            <i class="el-icon-question" />
          </el-tooltip>
        </el-form-item>
        <el-form-item label="应用简介：" prop="introduction">
          <el-input
            v-model="addApplicationForm.introduction"
            type="textarea"
            :rows="4"
            maxlength="50"
            placeholder="请输入应用简介，建议不超过五十个汉字！"
            class="handle-form-textarea"
          />
        </el-form-item>

        <el-form-item label="应用详情：" prop="describes">
          <Editor
            :decimal-num="1000"
            :editor-content="addApplicationForm.describes"
            :show-video="false"
            :show-img="false"
            @editorChange="editorChangeFn"
          />
        </el-form-item>
        <el-form-item label="应用视频：" prop="videoUrl" class="videoApp">
          <upload-file
            :props="{
              serveCode: 'small_app_logo',
              accept: '.mp4',
              type: ['video/mp4'],
              isMp4: true
            }"
            @uploadSucess="uploadSucessFnVideo"
            @fileUploading="fileUploadingFn"
            @typeError="typeError"
          >
            <el-button
              :loading="fileUploading"
              size="small"
              type="primary"
            >
              {{ fileUploading?'上传文件中...':addApplicationForm.videoUrl?'重新添加':'添加' }}
            </el-button>
          </upload-file>
          <span v-if="addApplicationForm.videoUrl" style="margin-left: 10px;">{{ addApplicationForm.videoUrl }}
            <i
              class="el-icon-delete"
              style="margin-left: 40px;color: #334EB4;"
              @click="()=>addApplicationForm.videoUrl=null"
            /></span>
          <upload-file
            :props="{
              serveCode: 'small_app_logo',
              accept: '.png, .jpg, .jpeg',
              type: ['image/jpeg', 'image/gif', 'image/png']
            }"
            @uploadSucess="uploadSucessVideoCoverFn"
          >
            <el-button>{{ addApplicationForm.videoCoverUrl?'重新添加封面':'添加封面' }}</el-button>
          </upload-file>
          <span v-if="addApplicationForm.videoCoverUrl" class="pictureUrls">
            <img

              :src="addApplicationForm.videoCoverUrl"
              class="avatar"
              @mouseover="()=>showImgDelCover=true"
            >
            <span v-show="showImgDelCover" class="mark" @mouseout="()=>showImgDelCover=false">
              <i
                class="el-icon-delete"
                @click="()=>addApplicationForm.videoCoverUrl=null"
              />
            </span>
          </span>
        </el-form-item>
        <el-form-item label="应用图片：" prop="pictureUrls" class="app-update">
          <span v-if="addApplicationForm.pictureUrls&&addApplicationForm.pictureUrls.length>0">
            <span v-for="(v,i) in addApplicationForm.pictureUrls" :key="v+i" class="pictureUrls">
              <img
                :src="v.url"
                class="avatar"
                @mouseover="()=>v.showImgDel=true"
              >
              <span v-show="v.showImgDel" class="mark" @mouseout="()=>v.showImgDel=false">
                <i
                  class="el-icon-delete"
                  @click="removePictureUrls(i)"
                />
              </span>
            </span></span>
          <span style="display:inline-block;">
            <upload-file
              :props="{
                serveCode: 'small_app_logo',
                accept: '.png, .jpg, .jpeg',
                type: ['image/jpeg', 'image/gif', 'image/png']
              }"
              @uploadSucess="uploadSucessPictureFn"
            >
              <i v-if="addApplicationForm.pictureUrls&&addApplicationForm.pictureUrls.length<9" class="el-icon-plus avatar-uploader-icon" />
            </upload-file>
          </span>
        </el-form-item>
        <el-form-item label="推荐：" class="recommend-box">
          <el-checkbox v-model="addApplicationForm.recommendHomePage" true-label="1" false-label="0">
            优智多官网趣味教学平台首页
          </el-checkbox>
          <div v-if="addApplicationForm.recommendHomePage==1" class="pic-box">
            <p><span style="color:red;">*</span> 应用配图：</p>
            <upload-file
              :props="{
                serveCode: 'small_app_logo',
                accept: '.png, .jpg, .jpeg',
                type: ['image/jpeg', 'image/gif', 'image/png']
              }"
              @uploadSucess="uploadSucessHomePage"
            >
              <img v-if="addApplicationForm.homePagePictureUrl" class="img-uploader" :src="addApplicationForm.homePagePictureUrl">
              <i v-else class="el-icon-plus avatar-uploader-icon img-uploader" />
            </upload-file>
          </div>
        </el-form-item>
      </el-form>
      <div class="addApplicationMange-footer">
        <el-button
          size="medium"
          @click="back"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          size="medium"
          :loading="ajaxLoading"
          @click="handleAddApplication"
        >
          {{ ajaxLoading ? '提交中...' : '提交' }}
        </el-button>
      </div>
    </div>
    <el-dialog :visible.sync="dialogImageVisible" title="预览图片">
      <img width="100%" :src="dialogImageUrl" alt>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAppTypeSelect,
  getGrades,
  getSubjects,
  appCode,
  addApp,
  updateApp
} from '@/api/productOperation/wisdom/applicationList';

import { mapGetters } from 'vuex';
export default {
  name: 'AddApplicationMange',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    handleType: {
      type: String,
      required: true
    },
    terminalList: {
      type: Array,
      default: () => []
    },
    applicationDetail: {
      type: Object,
      default: () => []
    },
    apptypesTree: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length > 50) {
        callback(new Error('应用简介不能大于50个汉字！'));
      } else if (value.length < 1) {
        callback(new Error('应用简介为必填项！'));
      } else {
        callback();
      }
    };
    return {
      showImgDelCover: false,
      appid: '',
      dialogImageVisible: false,
      dialogImageUrl: '',
      ajaxLoading: false, //  表单提交loading
      addApplicationForm: {
        code: '', // 应用编码
        name: '',
        describes: '',
        coefficient: '',
        logoPath: '',
        logoUrl: '',
        stageArr: [], // 年级
        appType: '', // 应用类型
        subjectArr: [], // 学科
        terminal: '',
        introduction: '',
        videoUrl: '',
        videoCoverUrl: '',
        pictureUrls: [],
        support: [], // 业务端
        recommendHomePage: 0,
        homePagePictureUrl: '',
        applyTypes: [],
        applyTerminals: [],
        studentClientDisplay: 0
      },
      checkAll: false,
      subjectCheckAll: false,
      isIndeterminate: true,
      appTypeArr: [], // 应用类型
      stageArr: [], // 年级
      subjectArr: [], // 学科
      fileUploading: false,
      codeArr: [], // 应用编码
      subjectIsIndeterminate: true,
      handleRules: {
        code: [{ required: true, message: '应用编码不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '应用名称不能为空', trigger: 'blur' }],
        appType: [{ required: true, message: '应用类型不能为空', trigger: 'blur' }],
        stageArr: [{ required: true, message: '年级不能为空', trigger: 'blur' }],
        subjectArr: [{ required: true, message: '学段不能为空', trigger: 'blur' }],
        terminal: [{ required: true, message: '应用标签不能为空', trigger: 'blur' }],
        support: [{ required: true, message: '业务端不能为空', trigger: 'blur' }],
        introduction: [{ required: true, validator: validatePass, trigger: 'blur' }],
        logoUrl: [{ required: true, message: 'logo不能为空', trigger: 'blur' }],
        describes: [{ required: true, message: '应用详情不能为空', trigger: 'blur' }],
        applyTypes: [{ required: true, message: '适用用户不能为空', trigger: 'blur' }],
        applyTerminals: [{ required: true, message: '支持终端不能为空', trigger: 'blur' }]
      },
      selected: false,
      disaibleSelect: true
    };
  },
  computed: {
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    terminalArr() {
      return [
        {
          id: 1,
          name: '联机应用'
        },
        {
          id: 2,
          name: '教师应用'
        },
        {
          id: 3,
          name: '学生应用'
        },
        {
          id: 4,
          name: '家校应用'
        }
      ];
    },
    updateStageArr() {
      return this.applicationDetail.gradeList.map(item => {
        return parseInt(item.code);
      });
    },
    updateSubjectArr() {
      return this.applicationDetail.subjectList.map(item => {
        return item.code;
      });
    },
    ...mapGetters(['currentProdeuctId', 'uploadFolder', 'userInfo']),
    userCode() {
      return this.userInfo.roleVOList[0].createUserCode;
    }
    // supportArr() {
    //   return [
    //     {
    //       id: 1,
    //       name: 'B端'
    //     },
    //     {
    //       id: 2,
    //       name: '趣味教学平台'
    //     }

    //   ];
    // }
  },
  mounted() {
    this.initForm();
    if (this.handleType === 'edit') {
      const pictureUrls = [];
      this.applicationDetail.pictureUrls.map((v) => {
        pictureUrls.push({ url: v, showImgDel: false });
      });
      this.addApplicationForm = {
        code: this.applicationDetail.code,
        name: this.applicationDetail.appName,
        describes: this.applicationDetail.details,
        coefficient: this.applicationDetail.downloads,
        logoPath: this.applicationDetail.appIconUrl,
        logoUrl: this.applicationDetail.appIconUrl,
        stageArr: this.updateStageArr,
        appType: this.applicationDetail.referenceId,
        subjectArr: this.updateSubjectArr,
        terminal: this.applicationDetail.terminalId,
        introduction: this.applicationDetail.introduction,
        videoUrl: this.applicationDetail.videoUrl,
        videoCoverUrl: this.applicationDetail.videoCoverUrl,
        pictureUrls: pictureUrls,
        recommendHomePage: this.applicationDetail.recommendHomePage ? this.applicationDetail.recommendHomePage.toString() : '',
        homePagePictureUrl: this.applicationDetail.homePagePictureUrl,
        applyTypes: this.applicationDetail.applyTypes ? this.applicationDetail.applyTypes : [],
        applyTerminals: this.applicationDetail.applyTerminals ? this.applicationDetail.applyTerminals : [],
        studentClientDisplay: this.applicationDetail.studentClientDisplay
      };
      this.appid = this.applicationDetail.id;
      this.disaibleSelect = this.applicationDetail.applyTerminals.indexOf('2') === -1;
    } else {
      this.$refs.addApplicationForm.resetFields();
    }
  },
  methods: {
    changeBox(e) {
      this.disaibleSelect = !e;
      if (e === false) {
        this.addApplicationForm.studentClientDisplay = 0;
      }
    },
    typeError(toLarge) {
      this.fileUploading = false;
      if (toLarge) {
        this.$message({
          type: 'error',
          message: '只允许上传小于500M的视频文件！'
        });
      } else {
        this.$message({
          type: 'error',
          message: '只支持mp4格式！'
        });
      }
    },
    initForm() {
      appCode().then(res => {
        this.codeArr = res.data;
      });
      getAppTypeSelect({ typeCode: 'C15' }).then((res) => {
        this.appTypeArr = res.data;
      });
      getGrades({ typeCode: 'C15' }).then((res) => {
        this.stageArr = res.data;
      });
      if (this.handleType === 'edit') {
        const data = {
          gradeIds: this.updateStageArr.toString(),
          typeCode: 'C15'
        };
        getSubjects(data).then(res => {
          this.subjectArr = res.data;
          const data = this.updateSubjectArr.map(item => {
            return item.toString();
          });
          this.addApplicationForm.subjectArr = data;
        });
      }
    },
    handleCheckAllChange(val) {
      var data = this.stageArr.map(item => {
        return item.id;
      });
      if (val) {
        const params = {
          gradeIds: data.toString(),
          typeCode: 'C15'
        };
        getSubjects(params).then((res) => {
          this.subjectArr = res.data;
        });
      } else {
        getSubjects({ gradeIds: -1, typeCode: 'C15' }).then((res) => {
          this.subjectArr = res.data;
        });
      }
      console.log(val);
      this.addApplicationForm.stageArr = val ? data : [];
      console.log(this.addApplicationForm.stageArr);
      this.isIndeterminate = false;
    },
    subjectCheckAllChange(val) {
      var data = this.subjectArr.map(item => {
        return item.subjectId;
      });
      this.addApplicationForm.subjectArr = val ? data : [];
      console.log(this.addApplicationForm.subjectArr);

      this.subjectIsIndeterminate = false;
    },
    subjectClick(item) { // 学科选择
      const checkedCount = item.length;
      this.subjectCheckAll = checkedCount === this.subjectArr.length;
      this.subjectIsIndeterminate = checkedCount > 0 && checkedCount < this.subjectArr.length;
    },
    stageClick(item) {
      // 年级选择
      if (item.length < 1) {
        item = ['-1'];
      }
      const checkedCount = item.length;
      this.checkAll = checkedCount === this.stageArr.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.stageArr.length;
      const data = {
        gradeIds: item.toString(),
        typeCode: 'C15'
      };
      getSubjects(data).then((res) => {
        this.subjectArr = res.data;
      });
    },
    editorChangeFn(val) {
      // const text = val.replace(/<p>/gi, '<p style="font-size: 13px">');
      this.addApplicationForm.describes = val;
    },
    uploadSucessFn(val) {
      this.addApplicationForm.logoPath = val.relativePath;
      this.addApplicationForm.logoUrl = val.absolutePath;
      this.fileUploading = false;
    },
    uploadSucessPictureFn(val) {
      this.addApplicationForm.pictureUrls = [...this.addApplicationForm.pictureUrls, { url: val.absolutePath, showImgDel: false }];
      this.fileUploading = false;
    },
    uploadSucessHomePage(val) {
      this.addApplicationForm.homePagePictureUrl = val.absolutePath;
      this.fileUploading = false;
    },
    uploadSucessVideoCoverFn(val) {
      this.addApplicationForm.videoCoverUrl = val.absolutePath;
      this.fileUploading = false;
    },
    uploadSucessFnVideo(val) {
      this.addApplicationForm.videoUrl = val.absolutePath;
      this.fileUploading = false;
    },
    removePictureUrls(index) {
      this.addApplicationForm.pictureUrls.splice(index, 1);
    },
    fileUploadingFn(val) {
      this.fileUploading = val;
    },
    apkParserFn(file) {
      const ApkParser = require('app-info-parser/src/apk');
      const parser = new ApkParser(file);
      parser
        .parse()
        .then((result) => {
          console.log('app info ----> ', result);
          console.log('icon base64 ----> ', result.icon);
        })
        .catch((err) => {
          console.log('err ----> ', err);
          this.$notify.success({
            title: 'error',
            message: '上传出错，请检查安装包是否正确！',
            showClose: false,
            duration: 2000
          });
        });
    },
    // 返回
    back() {
      // true 提示， false直接返回
      if (this.handleType !== 'add') {
        this._visible = false;
        return;
      }
      const flag = Object.values(this.addApplicationForm).some((item) => {
        return item.length > 0;
      });
      if (!flag) {
        this._visible = false;
      } else {
        this.$confirm('您已输入部分内容，是否确认返回?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this._visible = false;
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消返回!'
            });
          });
      }
    },
    // 限制input只能输入数字
    numberInput(val) {
      if (val) {
        this.addApplicationForm.coefficient = val.replace(/[^\d.]/g, '');
      }
    },
    // 添加应用
    handleAddApplication() {
      if (this.addApplicationForm.recommendHomePage === '1' && !this.addApplicationForm.homePagePictureUrl) {
        this.$message.error('请上传推荐图');
        return;
      }
      var gradeListData = [];
      this.stageArr.map(o => {
        this.addApplicationForm.stageArr.map(item => {
          if (o.id === item) {
            gradeListData.push(o);
            return o;
          }
        });
      });
      var gradeList = gradeListData.map(o => { return { code: o.id, name: o.name }; });
      var subjectListData = [];
      this.subjectArr.map(o => {
        this.addApplicationForm.subjectArr.map(item => {
          if (o.subjectId === item) {
            subjectListData.push(o);
            return o;
          }
        });
      });
      var subjectList = subjectListData.map(o => { return { code: o.subjectId, name: o.subjectName }; });
      this.$refs['addApplicationForm'].validate((valid) => {
        if (valid) {
          const data = {
            code: this.addApplicationForm.code,
            appName: this.addApplicationForm.name,
            referenceId: this.addApplicationForm.appType,
            appIconUrl: this.addApplicationForm.logoUrl,
            terminalId: this.addApplicationForm.terminal,
            gradeList: gradeList,
            subjectList: subjectList,
            downloads: this.addApplicationForm.coefficient,
            introduction: this.addApplicationForm.introduction,
            details: this.addApplicationForm.describes,
            createUserCode: this.userCode,
            status: '1',
            videoUrl: this.addApplicationForm.videoUrl,
            videoCoverUrl: this.addApplicationForm.videoCoverUrl,
            pictureUrls: this.addApplicationForm.pictureUrls.length > 0 ? this.addApplicationForm.pictureUrls.map(v => v.url) : [],
            typeCode: 'C15',
            recommendHomePage: this.addApplicationForm.recommendHomePage,
            homePagePictureUrl: this.addApplicationForm.homePagePictureUrl,
            applyTypes: this.addApplicationForm.applyTypes,
            applyTerminals: this.addApplicationForm.applyTerminals,
            studentClientDisplay: this.addApplicationForm.studentClientDisplay
          };
          if (data.videoUrl && !data.videoCoverUrl) {
            this.$message.warning('添加视频的必须添加封面');
            return;
          }
          this.ajaxLoading = true;
          if (this.handleType === 'add') {
            addApp(data)
              .then((result) => {
                this.$notify.success({
                  title: 'Success',
                  message: '添加成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this.$emit('onSuccess');
                this._visible = false;
              })
              .catch((err) => {
                console.log(err);
                this.ajaxLoading = false;
              });
          } else {
            updateApp(this.appid, data)
              .then((result) => {
                this.$notify.success({
                  title: 'Success',
                  message: '编辑成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this.$emit('onSuccess');
                this._visible = false;
              })
              .catch((err) => {
                console.log(err);
                this.ajaxLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          this.ajaxLoading = false;
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.addApplicationMange {
  .add-application-wrapper {
    .add-application-form {
      .avatar-uploader .el-upload {
        // border: 1px dashed #d9d9d9;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        border: 1px dashed #d9d9d9;
        font-size: 28px;
        color: #8c939d;
        width: 150px;
        height: 150px;
        line-height: 150px;
        text-align: center;
        vertical-align: top;
      }
      .recommend-box{
        .img-uploader{
          width: 350px;
          height: 150px;
        }
      }
      .avatar {
        border: 1px solid #d9d9d9;
        width: 150px;
        height: 150px;
        display: inline-block;
      }
    }
  }
}
.app-update {
  position: relative;
}
.update-text {
  position: absolute;
  left: 180px;
  bottom: 10px;
}
</style>
<style lang="scss" scoped>
.addApplicationMange {
  .add-application-wrapper {
    .add-application-form {
      .handle-form-input {
        width: 350px;
      }
      .downNum {
        margin-left: 20px;
      }
      .handle-form-apptypes {
        width: 50%;
      }
      .handle-form-textarea {
        width: 500px;
      }
    }
    .addApplicationMange-footer {
      text-align: center;
      padding: 20px;
    }
  }
}
.group{
  max-width: 800px;
}
.videoApp{
  .modify-avatar{margin-right:10px;}
}
.pictureUrls{
  position: relative;
  display: inline-block;
  line-height: 0;
  font-size: 0;
  margin-right: 10px;
  .mark{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0,0,0,0.2);
    color: #fff;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-icon-delete{cursor: pointer;}
  }
}
</style>
